import {

    GET_STARASSIGNMENT_LIST,
    GET_STARTYPES_LIST,
    GET_STARASSIGNMENT_TYPE_CATEGORY,
    GET_STATE_LOADING,
    GET_CARDSLIST,
    GET_LIST_HISTORICAL_TEMPLATE,
    GET_POST_TEMPLATE,
    GET_DOWNLOAD_TEMPLATE,

} from "@/views/star_assignment/store/types/types.js";

const getters = {
    [GET_STARASSIGNMENT_LIST]: state => state.typeDocumentStarassignment,
    [GET_STARTYPES_LIST]: state => state.typeStar,
    [GET_STARASSIGNMENT_TYPE_CATEGORY]: state => state.typeCategoryStarAssignment,
    [GET_STATE_LOADING]: state => state.loading,
    [GET_CARDSLIST]: state => state.cardsList,
    [GET_LIST_HISTORICAL_TEMPLATE]:  state => state.template,
    [GET_POST_TEMPLATE]:  state => state.templateDownload,
    [GET_DOWNLOAD_TEMPLATE]:  state => state.templateDownload,
};

export default getters;